module.exports = __webpack_public_path__ + "img/art-random.ee2af353.png";